import React from "react";
import {WizTableForm} from '@/containers/common'

const program = WizTableForm.Config.program(this, {apiParams: {isPower: true}})

//配置项
const componentName = "programReport";

function columns() {
  return [
    {
      title: "课程名称",
      name: "programName",
      tableItem: {},
    },
    {
      title: "课程名称",
      name: "programIds",
      searchItem: {
        ...program,
        diy: WizTableForm,
        rules: [
          {
            required: true,
            message: '请选择课程名称'
          }
        ]
      },
    },
    {
      title: "课程编码",
      name: "scoId",
      tableItem: {},
    },
    {
      title: "课程分类",
      name: "programCategoryName",
      tableItem: {
        type: 'popover'
      },
    },
    {
      title: "归属部门",
      name: "programSource",
      tableItem: {},
      searchItem: {}
    },
    {
      title: "课程状态",
      name: "status",
      tableItem: {},
      searchItem: {
        type: 'select'
      },
      dict: [
        {code: 0, codeName: '草稿'},
        {code: 1, codeName: '发布'},
        {code: 2, codeName: '关闭'},
      ]
    },
    {
      title: "应学习人数",
      name: "shoudCount",
      tableItem: {},
    },
    {
      title: "已学习人数",
      name: "factCount",
      tableItem: {},
    },
    {
      title: "课程学习率",
      name: "rate",
      tableItem: {
        render: text => text + '%'
      },
    },
    {
      title: "通过人数",
      name: "passCount",
      tableItem: {},
    },
    {
      title: "通过率",
      name: "passRate",
      tableItem: {
        render: text => text + '%'
      },
    }, 
    {
      title: "学习总人次",
      name: "studyTotal",
      tableItem: {},
    },
    {
      title: "未学习人数",
      name: "notStudy",
      tableItem: {},
    },
    {
      title: "学习总时长(时)",
      name: "totalTime",
      tableItem: {},
    },
    {
      title: "人均学习时长(时)",
      name: "avgTime",
      tableItem: {},
    },
    {
      title: "课程评分(当前)",
      name: "starScore",
      tableItem: {},
    },
    {
      title: "评论数",
      name: "commentCount",
      tableItem: {},
    },
    {
      title: "创建时间",
      name: "createTime",
      tableItem: {},
    },
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ]
        },
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageListProgram`,
    payload: {
      key: `${componentName}@getPageListProgram`,
      apiParams: {pageNum: 1, pageSize: 10},
    },
  },
  export: {
    path: `${componentName}/exportProgram`,
    payload: {
      key: `${componentName}@exportProgram`,
      apiParams: {}
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    ...args,
  };
};

export {reduxTemplateCofig, templateConfig};
